import { Editor, EditorState, Modifier, ContentState } from "draft-js";
import { Button, Card, Input, message, Modal, Select } from "antd";
import React, { useEffect, useState } from "react";

import { placeholderDecorator } from "./utils";

import closeCircle from "../../assets/icons/close-circle.svg";
import paperclip from "../../assets/icons/paperclip-2.svg";
import additem from "../../assets/icons/additem.svg";
import edit from "../../assets/icons/edit-2.svg";
import { controller } from "./controller";

export default function EditEmailTemplateModal({ selectedTemplateToEdit, showEditTemplate, setShowEditTemplate, isSms }) {
  const [showEditEmailNameInput, setShowEditEmailNameInput] = useState(false);
  const [showEditEmailSubjectInput, setShowEditEmailSubjectInput] = useState(false);
  const [editorState, setEditorState] = useState(() => EditorState.createEmpty(placeholderDecorator));
  const [emailTemplateName, setEmailTemplateName] = useState(selectedTemplateToEdit.name || "");
  const [emailSubject, setEmailSubject] = useState(selectedTemplateToEdit.subject || "");
  const [emailTemplateText, setEmailTemplateText] = useState(selectedTemplateToEdit.text || "");
  const [showDynamicSelectItem, setShowDynamicSelectItem] = useState(false);
  const [showEditEmailText, setShowEditEmailText] = useState(false);

  // Placeholder options for the dropdown
  const dynamicItemOptions = [
    { label: "Patient Name", value: "Patient Name" },
    { label: "Office Name", value: "Office Name" },
  ];

  // Updating the email text state
  useEffect(
    function () {
      const newText = editorState.getCurrentContent().getPlainText();
      setEmailTemplateText(newText);
    },
    [editorState.getCurrentContent().getPlainText()]
  );

  // Function to insert a placeholder at the current cursor position
  const insertPlaceholder = (placeholder) => {
    const currentContent = editorState.getCurrentContent();
    const selection = editorState.getSelection();
    const contentStateWithPlaceholder = Modifier.insertText(currentContent, selection, placeholder);
    const newEditorState = EditorState.push(editorState, contentStateWithPlaceholder, "insert-characters");
    setEditorState(EditorState.forceSelection(newEditorState, contentStateWithPlaceholder.getSelectionAfter()));
    setShowDynamicSelectItem(false);
  };

  // Function to toggle email text edit mode and populate editor
  const toggleEmailTextEdit = () => {
    if (!showEditEmailText) {
      // Entering edit mode: populate editor with current email text
      const contentState = ContentState.createFromText(emailTemplateText);
      const newEditorState = EditorState.createWithContent(contentState, placeholderDecorator);
      setEditorState(newEditorState);
    } else {
      // Exiting edit mode: save editor content to emailText
      // const content = editorState.getCurrentContent().getPlainText();
      const originalEmailText = selectedTemplateToEdit.text;
      setEmailTemplateText(originalEmailText);
    }
    setShowEditEmailText(!showEditEmailText);
  };

    const handleEditTemplate = async () => {
    try {
      // Get the plain text content from the editor
      const bodyContent = editorState.getCurrentContent().getPlainText();    
      //Convert placeholders to the required format:Replace "Patient Name" with "{?patient_name?}" and "Office Name" with "{?office_name ?}"
      const formattedBody = bodyContent
        .replace(/Patient Name/g, '{?patient_name?}')
        .replace(/Office Name/g, '{?office_name?}');
      
      const edittedTemplate = {
        name: emailTemplateName,        
        subject: isSms ? undefined : emailSubject,
        text: formattedBody,
      }      
      console.log('Sending template:', edittedTemplate);
      const response = await controller.editEmailTemplate(selectedTemplateToEdit.id, edittedTemplate, isSms);
      console.log("Email created", response);
      message.success(`${isSms ? "SMS" : "Email"} template created successfully!`);
      setShowEditTemplate(false);   

    } catch (err) {
      console.error("Error editting template:", err);
      message.error(`${isSms ? "SMS" : "Email"} template not editted!`);
    }
  }

  return (
    <Modal
      open={showEditTemplate}
      title={<span style={{ fontSize: 18 }}>Email Template Preview</span>}
      footer={
        <Button type="primary" style={{ padding: "17px 30px", marginTop: 15, fontSize: 16 }} onClick={handleEditTemplate}>
          Save Changes
        </Button>
      }
      onCancel={() => setShowEditTemplate(false)}
      width={600}
    >
      <div style={{ display: "flex", flexDirection: "column", gap: 20, marginTop: 20 }}>
        {/* Email/Sms Template Name */}
        <div>
          <div style={{ display: "flex", alignItems: "center", justifyContent: "space-between" }}>
            <p style={{ color: "#848696", marginBottom: 10, fontSize: 16 }}>Email Template Name</p>

            {showEditEmailNameInput ? (
              <img src={closeCircle} alt="close" style={{ cursor: "pointer" }} onClick={() => setShowEditEmailNameInput(false)} />
            ) : (
              <img src={edit} alt="edit" style={{ cursor: "pointer" }} onClick={() => setShowEditEmailNameInput(true)} />
            )}
          </div>

          {showEditEmailNameInput ? (
            <Input
              placeholder="Enter Email Template Name"
              value={emailTemplateName}
              onChange={(e) => setEmailTemplateName(e.target.value)}
              style={{ border: "1px solid #6B43B5" }}
            />
          ) : (
            <span style={{ fontSize: 16 }}>{emailTemplateName}</span>
          )}
        </div>

        {/* Email Subject */}
        {!isSms &&
          <div>
            <div style={{ display: "flex", alignItems: "center", justifyContent: "space-between" }}>
              <p style={{ color: "#848696", marginBottom: 10, fontSize: 16 }}>Email Subject</p>
              {showEditEmailSubjectInput ? (
                <img src={closeCircle} alt="close" style={{ cursor: "pointer" }} onClick={() => setShowEditEmailSubjectInput(false)} />
              ) : (
                <img src={edit} alt="edit" style={{ cursor: "pointer" }} onClick={() => setShowEditEmailSubjectInput(true)} />
              )}
            </div>

            {showEditEmailSubjectInput ? (
              <Input
                placeholder="Enter Email Subject"
                value={emailSubject}
                onChange={(e) => setEmailSubject(e.target.value)}
                style={{ border: "1px solid #6B43B5" }}
              />
            ) : (
              <span style={{ fontSize: 16 }}>{emailSubject}</span>
            )}
          </div>
        }

        {/* Email/Sms Text */}
        <div>
          <div style={{ display: "flex", alignItems: "center", justifyContent: "space-between" }}>
            <p style={{ color: "#848696", marginBottom: 10, fontSize: 16 }}>Email Text</p>
            {showEditEmailText ? (
              <img src={closeCircle} alt="close" style={{ cursor: "pointer" }} onClick={toggleEmailTextEdit} />
            ) : (
              <img src={edit} alt="edit" style={{ cursor: "pointer" }} onClick={toggleEmailTextEdit} />
            )}
          </div>

          <Card className="text-email-template">
            {showEditEmailText ? (
              <>
                <div
                  className="custom-scroll"
                  style={{
                    minHeight: 100,
                    maxHeight: 200,
                    width: "100%",
                    maxWidth: showDynamicSelectItem ? 312 : 506,
                    resize: "none",
                    overflowY: "auto",
                  }}
                >
                  <Editor
                    editorState={editorState}
                    onChange={setEditorState}
                    blockStyleFn={() => "custom-email-editor"}
                    placeholder="Write your email here..."
                  />
                </div>

                <div style={{ display: "flex", flexDirection: "column", alignItems: "end", gap: showDynamicSelectItem ? 5 : 10 }}>
                  <div>
                    {!showDynamicSelectItem ? (
                      <img src={additem} alt="add-item" style={{ cursor: "pointer" }} onClick={() => setShowDynamicSelectItem(true)} />
                    ) : (
                      <div style={{ position: "relative", padding: 5 }}>
                        <img
                          src={closeCircle}
                          alt="close"
                          style={{ position: "absolute", right: 0, top: 0, width: 14, zIndex: 1000, backgroundColor: "white", cursor: "pointer" }}
                          onClick={() => setShowDynamicSelectItem(false)}
                        />
                        <Select
                          options={dynamicItemOptions}
                          placeholder="Select Dynamic Item"
                          className="dynamic-select-item"
                          onChange={(value) => insertPlaceholder(value)}
                          style={{ width: 200 }}
                        />
                      </div>
                    )}
                  </div>

                  <div>
                    <img src={paperclip} alt="paper-clip" style={{ cursor: "pointer" }} />
                  </div>
                </div>
              </>
            ) : (
              <p>{emailTemplateText}</p>
            )}
          </Card>
        </div>
      </div>
    </Modal>
  );
}
